import { RichLink } from "./links";
import { Accessory } from "./accessory";

export interface ConfigAccessory {
  accessoryLink: RichLink;
  disabled: boolean;
  name: string;
  hidden: boolean;
  featured?: boolean;
  tagLine: string;
  details: string[];
  preLoad: boolean;
  pbsName: string;
  pbsType: string;
  options: ConfigAccessoryOption[];
}

export interface ConfigAccessoryOption {
  name: string;
  label: string;
  pbsName: string;
  defaultSelection: boolean;
  price: number;
  cost: number;
  details: string[];
}

export function convertToAccessory(configAccessory: ConfigAccessory, optionIndex: number): Accessory {
  let name = configAccessory.name;
  if (configAccessory.options?.[optionIndex]?.name) {
    name += " - " + configAccessory.options[optionIndex].name;
  }

  return {
    name: name,
    accessoryLink: configAccessory.accessoryLink,
    disabled: configAccessory.disabled,
    hidden: configAccessory.hidden,
    featured: configAccessory.featured,
    tagLine: configAccessory.tagLine,
    preLoad: configAccessory.preLoad,
    pbsType: configAccessory.pbsType,
    price: configAccessory.options?.[optionIndex]?.price || 0,
    cost: configAccessory.options?.[optionIndex]?.cost || 0,
    details: configAccessory.options?.[optionIndex]?.details || [],
    pbsName: configAccessory.options?.[optionIndex]?.pbsName || configAccessory.pbsName,
  }
}